import { render, staticRenderFns } from "./PlusThickIcon.vue?vue&type=template&id=a7d44372"
import script from "./PlusThickIcon.vue?vue&type=script&lang=js"
export * from "./PlusThickIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports